export default __webpack_public_path__ + "static/media/generate_inactive.dc565eeb.svg";